<template>
  <div class="my-table">
    <el-table :data="data" height="500">
      <my-column v-for="(item,index) in col" :key="index" :col="item"></my-column>
    </el-table>
  </div>
</template>

<script>
import MyColumn from "./MyColumn";
export default {
  components: {
    MyColumn
  },
  props: {
    col: {
      type: Array
    },
    data: {
      type: Array
    }
  }
};
</script>
<style>
.el-table thead {
  color: #2c3e50;
}
.el-table thead.is-group th {
  background: #dfefff;
}
.el-table--border th {
  border-bottom: 1px solid #fff;
  border-right: 1px solid #fff;
}
.el-table .cell {
  font-weight: 400;
}
.el-table td,
.el-table th {
  padding: 8px 0px;
}
/* tbody tr:nth-child(2n){
  background: #f4f4f4;
} */
</style>